/**
 * 支援的語言設定
 */

export const SUPPORTED_LANGUAGES = {
  'en': 'English',
  'zh-TW': '繁體中文',
};

export const DEFAULT_LANGUAGE = 'en';

/**
 * 驗證語言是否支援
 * @param {string} language - 語言代碼
 * @returns {boolean} - 是否支援
 */
export function isLanguageSupported(language) {
  return language && Object.prototype.hasOwnProperty.call(SUPPORTED_LANGUAGES, language);
}

/**
 * 取得支援的語言或回傳預設語言
 * @param {string} language - 語言代碼
 * @returns {string} - 支援的語言代碼
 */
export function getSupportedLanguageOrDefault(language) {
  return isLanguageSupported(language) ? language : DEFAULT_LANGUAGE;
}